import React from 'react';
import { CircleInfo, TrashBin } from '@gravity-ui/icons';
import { Plugin } from 'prosemirror-state';
import { noteType } from '../../../../extensions/yfm';
import { i18n } from '../../../../i18n/yfm-note';
import { BaseTooltipPluginView } from '../../../../plugins/BaseTooltip';
import { Toolbar, ToolbarDataType } from '../../../../toolbar';
import { removeNode } from '../../../../utils/remove-node';
import './index.css';
var YfmNoteType;
(function (YfmNoteType) {
    YfmNoteType["tip"] = "tip";
    YfmNoteType["info"] = "info";
    YfmNoteType["warning"] = "warning";
    YfmNoteType["alert"] = "alert";
})(YfmNoteType || (YfmNoteType = {}));
const isEnable = () => true;
const isActive = () => false;
const changeType = (type) => ({ node, pos, dispatch, tr }) => {
    dispatch(tr.setNodeMarkup(pos, null, Object.assign(Object.assign({}, node.attrs), { class: `yfm-note yfm-accent-${type}`, 'note-type': type })));
};
export const yfmNoteTooltipPlugin = ({ actions, schema }) => new Plugin({
    view(view) {
        return new BaseTooltipPluginView(view, {
            idPrefix: 'yfm-note-tooltip',
            nodeType: noteType(view.state.schema),
            popupPlacement: ['bottom', 'top'],
            content: (view, { node, pos }) => (React.createElement(Toolbar, { editor: actions, focus: () => view.focus(), className: "ye-yfm-note-toolbar", data: [
                    [
                        YfmNoteType.info,
                        YfmNoteType.tip,
                        YfmNoteType.warning,
                        YfmNoteType.alert,
                    ].map((type) => ({
                        id: `note-type-${type}`,
                        icon: { data: CircleInfo },
                        title: i18n(type),
                        type: ToolbarDataType.SingleButton,
                        isActive,
                        isEnable,
                        exec: () => changeType(type)({
                            schema,
                            pos: pos,
                            node: node,
                            tr: view.state.tr,
                            dispatch: view.dispatch.bind(view),
                        }),
                    })),
                    [
                        {
                            id: 'note-remove',
                            icon: { data: TrashBin },
                            title: i18n('remove'),
                            type: ToolbarDataType.SingleButton,
                            isActive,
                            isEnable,
                            exec: () => removeNode({
                                pos: pos,
                                node: node,
                                tr: view.state.tr,
                                dispatch: view.dispatch.bind(view),
                            }),
                        },
                    ],
                ] })),
        });
    },
});
